// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-container[data-v-2bd9c46e]{background:rgba(2,195,204,.1);padding-bottom:500px}.second-box[data-v-2bd9c46e]{top:350px;z-index:9;right:125px}.third-box[data-v-2bd9c46e]{z-index:9;box-shadow:-14px 10px 30px rgba(16,11,73,.08)}@media screen and (max-width:768px){.third-box[data-v-2bd9c46e]{bottom:0;z-index:9;right:30px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
